<template>
  <div class="layout-index">
    <LayoutHeader />
    <div
      v-if="loadOver"
      class="app-carousel"
    >
      <Swiper
        v-if="!hiddenCarousel && carouselImgs.length"
        :key="carouselKey"
        class="main-swiper"
        :options="swiperOption"
      >
        <Swiper-slide v-for="(item, index) in carouselImgs" :key="index">
          <img :src="item.logo ? item.logo : item.src" alt="" />
        </Swiper-slide>
        <div class="swiper-button-prev" slot="button-prev">
          <i class="fa fa-angle-left"></i>
        </div>
        <div class="swiper-button-next" slot="button-next">
          <i class="fa fa-angle-right"></i>
        </div>
        <div slot="pagination" class="swiper-pagination"></div>
      </Swiper>
      <div v-else class="other-banner">
        <img src="@/assets/images/banner02.png" alt="" />
      </div>
    </div>
    <div style="min-height: 50vh">
      <slot></slot>
    </div>
    <LayoutFooter />
  </div>
</template>

<script>
import LayoutHeader from "./header";
import LayoutFooter from "./footer";
import { cmsCatalogContentAllList } from "@/api/index";

const DEFAULT_CAROUSEL_CATALOG_ALISA = "picture";

export default {
  name: "LayoutIndex",
  components: {
    LayoutHeader,
    LayoutFooter,
  },
  data() {
    return {
      swiperOption: {
        autoplay: {
          delay: 6500,
          disableOnInteraction: false,
        },
        loop: true,
        direction: "horizontal",
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
        },
      },
      carouselImgs: [],
      hiddenCarousel: false,
      loadOver: false, // 是否加载完成，避免首次需要隐藏的页面会闪一下
      carouselKey: 0,
      carouselRequestId: 0,
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        this.handleRouteChange(to);
      },
    },
  },
  methods: {
    async handleRouteChange(to) {
      const requestId = ++this.carouselRequestId;
      this.loadOver = false;
      this.carouselImgs = [];
      this.carouselKey += 1;

      this.hiddenCarousel = false;

      try {
        let carouselImgs = [];

        // A route can override the shared carousel alias when needed.
        const catalogAlisa =
          to.meta.carouselCatalogAlisa || DEFAULT_CAROUSEL_CATALOG_ALISA;
        const res = await cmsCatalogContentAllList({
          catalogAlisa,
        });
        carouselImgs = res.data.contentList[0]?.imageList || [];

        if (requestId !== this.carouselRequestId) {
          return;
        }

        this.carouselImgs = carouselImgs;
      } catch (error) {
        if (requestId !== this.carouselRequestId) {
          return;
        }
        this.carouselImgs = [];
      } finally {
        if (requestId === this.carouselRequestId) {
          this.carouselKey += 1;
          this.loadOver = true;
        }
      }
    },
  },
};
</script>

<style scoped lang="less">
@media screen and (max-width: 768px) {
  .app-carousel {
    height: 13rem !important;
  }
  .ly-container {
    max-width: 100% !important;
  }
}
.app-carousel {
  height: 500px;
  .main-swiper {
    height: 100%;
    width: 100%;
    &::v-deep {
      .swiper-pagination {
        display: flex !important;
        justify-content: flex-end;
      }
      .swiper-pagination-bullet {
        background-color: #ffffff;
        width: 12px;
        height: 12px;
        opacity: 1;
      }
      .swiper-pagination-bullet-active {
        background-color: #5b2400;
      }
    }

    img {
      height: 100%;
      width: 100%;
    }
    .swiper-button-prev,
    .swiper-button-next {
      width: 40px;
      text-align: center;
      line-height: 44px;
      padding: 10px 0;
      background-image: none;
      transition: background-color 0.3s;
      font-size: 38px;
      color: white;
      &:hover {
        background-color: rgba(0, 0, 0, 0.6);
      }
    }
    .swiper-button-prev {
      left: 0;
    }
    .swiper-button-next {
      right: 0;
    }
  }
  .other-banner {
    width: 100%;
    height: 100%;
  }
}
</style>
